import { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import InvitationForm from './components/InvitationForm';

const InvitePage = (): ReactElement => (
  <>
    <HeadTag title="Invitation" />
    <InvitationForm />
  </>
);

export default InvitePage;
